import PropTypes from 'prop-types';
// @mui
import { TableRow, TableCell, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// // utils
import { fDate } from '../../utils/formatTime';

const StyledTypography = styled(Typography)(({ theme }) => ({
  '&': {
    color: '#fff',
    fontSize: '13px',
    fontWeight: 400,
  },
}));

// ----------------------------------------------------------------------

MyClaimTableRow.propTypes = {
  row: PropTypes.object,
};

export default function MyClaimTableRow({ row }) {
  const {
    // id,
    // account_id,
    // account_domain_id,
    // member_id,
    // user_id,
    // session_id,
    // company_id,
    // to_company_id,
    // game_id,
    // transaction_id,
    // currency_id,
    date,
    title,
    // turnover,
    // commission,
    // saldo_awal,
    // debit,
    // credit,
    // last_balance: lastBalance,
    // note,
    // type,
    // is_demo,
    // is_reporting,
    // is_claim: isClaim,
    // is_read: isRead,
    // status,
    // modified,
    // created,
    amount,
  } = row?.History;

  return (
    <TableRow hover>
      <TableCell>
        <StyledTypography
          sx={{
            color: '#FF9D00 !important',
          }}
        >
          {title || '-'}
        </StyledTypography>
      </TableCell>

      <TableCell>
        <StyledTypography
          sx={{
            color: '#FF9D00 !important',
          }}
        >
          {fDate(date)}
        </StyledTypography>
      </TableCell>

      <TableCell align="right">
        <StyledTypography
          sx={{
            color: '#FF9D00 !important',
          }}
        >
          {amount || '-'}
        </StyledTypography>
      </TableCell>
    </TableRow>
  );
}
